import React, { useEffect, useState, useRef } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';

import Asterisk from 'components/Asterisk';

const EDUCATIONS2 = require('jsons/educations2.json');
const COURSE_DURATIONS = require('jsons/course_durations.json');

const WorkExperienceProfileBoxEdit = (props) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    setProfile(props.profile);
  }, [props]);

  const updateProfile = (field, value) => {
    const updatedProfile = {
      ...profile,
      [field]: value
    };
    setProfile(updatedProfile);
    props.onChange(profile.id, updatedProfile);
  };

  const deleteProfile = () => {
    props.onDelete(profile.id);
  };

  return (profile === null ?
    <></>
  :
    <Card className="work-experience-profile-box mb-3 relative">
      <div className="grid flex user-detail-user">
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">教育程度 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <Dropdown value={EDUCATIONS2.zh.filter(item => parseInt(item.id)===profile.education_id)[0]} onChange={(e) => updateProfile('education_id', parseInt(e.value.id))} options={EDUCATIONS2.zh} optionLabel="name" placeholder="選擇" className="w-full" />
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">課程長度 <Asterisk /></label>
          <div className="flex flex-wrap gap-3">
            <Dropdown value={COURSE_DURATIONS.zh.filter(item => parseInt(item.id)===profile.course_duration_id)[0]} onChange={(e) => updateProfile('course_duration_id', parseInt(e.value.id))} options={COURSE_DURATIONS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <div className="flex align-items-center">
              <Checkbox inputId="completed" name="completed" onChange={(e) => {updateProfile('completed', e.checked)}} checked={profile.completed} />
              <label htmlFor="completed" className="ml-2">完成課程</label>
          </div>
        </div>
        <div className="col-6 flex flex-column gap-1">
          <label className="font-semibold">完成/最後上課年份 <Asterisk /></label>
          <InputNumber value={profile.completion_year} onChange={(e) => {updateProfile('completion_year', e.value)}} useGrouping={false} inputClassName="w-full text-right" maxLength={4} />
        </div>
      </div>
      <Button icon="pi pi-times" onClick={deleteProfile} rounded severity="danger" style={{ top: -8, right: -8, width: 24, height: 24 }} className="absolute" />
    </Card>
  );
};

export default WorkExperienceProfileBoxEdit;